import React from "react";
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  Checkbox,
  Table,
  Empty
} from "antd";
import moment from "moment";
import "./styles.css";
import { FORMAT_3DECIMALS, GREATER_THAN_ZERO } from "../../../common/types/regularExpresionType";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModalVer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;

    getFieldDecorator("destinatarios", {
      initialValue: this.props.formValues.destinatarios.filter((m) => {
        return m.id === this.props.formValues.idDestinatario;
      }),
    });

    getFieldDecorator("remitentes", {
      initialValue: this.props.formValues.remitentes.filter((m) => {
        return m.id === this.props.formValues.idRemitente;
      }),
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });

    return (
      <Modal
        title={<div>Ver Guía de Transportista</div>}
        visible={this.props.visible}
        style={{ top: 30 }}
        cancelText={"Cancelar"}
        okText={"Ok"}
        onCancel={this.handleCancel}
        onOk={this.handleCancel}
        width="1050px"
      >
        <Form>
          {getFieldDecorator("id", { initialValue: this.props.formValues.id })(
            <input type="hidden" />
          )}

          {getFieldDecorator("idComprobante", {
            initialValue: this.props.formValues.idComprobante,
          })(<input type="hidden" />)}

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        disabled={true}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Fecha">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        disabled
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Fecha Traslado">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaTrasladoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaTrasladoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de traslado"
                        disabled
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator('idProyecto', {
                  initialValue: this.props.formValues.idProyecto ?
                    { key: this.props.formValues.idProyecto } : -1
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                    disabled={this.props.formValues.isReadOnly}
                  >
                    <Option key={-1} value={-1}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


          </div>
          <div className="row">

            <div className="col-md-3 form-group">
              <Form.Item label="N° Documento">
                <Form.Item>
                  {getFieldDecorator("documentoRemitente", {
                    initialValue: this.props.formValues.documentoRemitente,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                        whitespace: true,
                      },
                    ],
                  })(
                    <Search
                      placeholder="Documento"
                      className="first-input"
                      autoComplete="off"
                      readOnly={true}
                      maxLength={20}
                    />
                  )}
                </Form.Item>

              </Form.Item>
            </div>
            <div className="col-md-9 form-group">
              <Form.Item label="Remitente">
                <Form.Item>
                  <InputGroup compact style={{ marginBottom: "1px" }}>
                    {getFieldDecorator("idRemitente", {
                      initialValue: this.props.formValues.idRemitente
                        ? { key: this.props.formValues.idRemitente }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        labelInValue
                        disabled

                        placeholder={"Búsqueda de Remitente"}
                        optionFilterProp="children"
                        showArrow={false}

                      >
                        {getFieldValue("remitentes").map((item) => (
                          <Option key={item.id} value={item.id} data={item}>
                            <Tag>{item.tipoDocumentoNombre}</Tag>
                            {`${item.nombre}`}
                          </Option>
                        ))}
                      </Select>
                    )}

                  </InputGroup>
                </Form.Item>
              </Form.Item>
            </div>



          </div>

          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="N° Documento">
                <Form.Item>
                  {getFieldDecorator("documentoDestinatario", {
                    initialValue: this.props.formValues.documentoDestinatario,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                        whitespace: true,
                      },
                    ],
                  })(
                    <Search
                      placeholder="Documento"
                      className="first-input"
                      autoComplete="off"
                      readOnly={true}
                      maxLength={20}
                    />
                  )}
                </Form.Item>

              </Form.Item>
            </div>

            <div className="col-md-9 form-group">
              <Form.Item label="Destinatario">
                <Form.Item>
                  <InputGroup compact style={{ marginBottom: "1px" }}>
                    {getFieldDecorator("idDestinatario", {
                      initialValue: this.props.formValues.idDestinatario
                        ? { key: this.props.formValues.idDestinatario }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select
                        showSearch
                        labelInValue
                        disabled
                        placeholder={"Búsqueda de Destinatario"}
                        optionFilterProp="children"
                        showArrow={false}
                      >
                        {getFieldValue("destinatarios").map((item) => (
                          <Option key={item.id} value={item.id} data={item}>
                            <Tag>{item.tipoDocumentoNombre}</Tag>
                            {`${item.nombre}`}
                          </Option>
                        ))}
                      </Select>
                    )}

                  </InputGroup>
                </Form.Item>

              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Partida">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("direccionPartida", {
                        initialValue: this.props.formValues.direccionPartida,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio mayor a 0.00",
                          },
                        ],
                      })(
                        <Input
                          readOnly={true}
                          placeholder="Ingresar dirección"
                          autoComplete="off"
                        />
                      )}

                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>

            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("idDepartamentoPartida", {
                  initialValue: this.props.formValues.idDepartamentoPartida
                    ? { key: this.props.formValues.idDepartamentoPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.departamentosPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("idProvinciaPartida", {
                  initialValue: this.props.formValues.idProvinciaPartida
                    ? { key: this.props.formValues.idProvinciaPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.provinciasPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("idDistritoPartida", {
                  initialValue: this.props.formValues.idDistritoPartida
                    ? { key: this.props.formValues.idDistritoPartida }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.distritosPartida.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 form-group">
              <Form.Item label="Dirección Llegada">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("direccionDestino", {
                        initialValue: this.props.formValues.direccionDestino,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                          },
                        ]
                      })(
                        <Input
                          placeholder="Ingresar Dirección de llegada"
                          autoComplete="off"
                        />
                      )}

                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>

            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Departamento">
                {getFieldDecorator("idDepartamentoLlegada", {
                  initialValue: this.props.formValues.idDepartamentoLlegada
                    ? { key: this.props.formValues.idDepartamentoLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.departamentosLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Provincia">
                {getFieldDecorator("idProvinciaLlegada", {
                  initialValue: this.props.formValues.idProvinciaLlegada
                    ? { key: this.props.formValues.idProvinciaLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"

                  >
                    {this.props.formValues.provinciasLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-2 form-group">
              <Form.Item label="Distrito">
                {getFieldDecorator("idDistritoLlegada", {
                  initialValue: this.props.formValues.idDistritoLlegada
                    ? { key: this.props.formValues.idDistritoLlegada }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"- Seleccione -"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.distritosLlegada.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div
              className="col-md-6 form-group"
            >
              <Form.Item label="Chofer">
                {getFieldDecorator("idChofer", {
                  initialValue: this.props.formValues.idChofer
                    ? { key: this.props.formValues.idChofer }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    disabled
                    placeholder={"Seleccione Chofer"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.choferes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.numeroDocumento}-{item.razonSocial}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>

            <div className="col-md-3 form-group">
              <Form.Item label="Licencia">
                {getFieldDecorator("licencia", {
                  initialValue: this.props.formValues.licencia,
                })(
                  <Input
                    placeholder=" licencia"
                    autoComplete="off"
                    readOnly={true}
                    className="second-input"
                  />
                )}
              </Form.Item>
            </div>



            <div className="col-md-3 form-group">
              <Form.Item label="Vehículo">
                {getFieldDecorator("idVehiculo", {
                  initialValue: this.props.formValues.idVehiculo
                    ? { key: this.props.formValues.idVehiculo }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    disabled
                    placeholder={"Seleccione Vehículo"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.vehiculos.map((item) => (
                      <Option key={item.id} value={item.id} data={item}>
                        {item.placa} ({item.marca}-{item.modelo}-{item.color})
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


            <div className="col-md-6 form-group">
              <Form.Item label="Indicador de envío SUNAT">
                {getFieldDecorator('idIndicadorSunat', {
                  initialValue: this.props.formValues.idIndicadorSunat ?
                    { key: this.props.formValues.idIndicadorSunat } : undefined
                })(
                  <Select showSearch labelInValue
                    placeholder={"Seleccione Indicador"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.indicadorSunat.map(item => (
                      <Option  key={item.id} value={item.id}>{item.nombre}</Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Tarjeta Única de Circulación (TUC)">
                {getFieldDecorator("tuc", {
                  initialValue: this.props.formValues.tuc,
                })(
                  <Input
                    placeholder="Número TUC"
                    autoComplete="off"
                    className="second-input"
                    readOnly={true}
                  />
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Nº de Registro MTC">
                {getFieldDecorator("nroMtc", {
                  initialValue: this.props.formValues.nroMtc,
                })(
                  <Input
                    placeholder="Número MTC"
                    autoComplete="off"
                    className="second-input"
                  />
                )}
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 form-group">
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                })(
                  <Input
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                    readOnly={true}
                  />
                )}
              </Form.Item>
            </div>


          </div>


          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={this.props.onChangeTab}
              >
                <TabPane tab="Detalle de Productos y Servicios" key="1">
                  <Table
                    className={"table-producto"}
                    scroll={{ x: true }}
                    size="small"
                    style={{ overflowX: "auto" }}
                    pagination={false}
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    rowKey={(record) => record.idProducto}
                    locale={{
                      emptyText: (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description="No se han agregado productos"
                        />
                      ),
                    }}
                    columns={[
                      {
                        title: "Código",
                        dataIndex: "codigo",
                        key: "codigo",
                        align: "center",
                        width: 80,
                        ellipsis: true,
                      },
                      {
                        title: "Nombre",
                        dataIndex: "nombre",
                        key: "nombre",
                        align: "center",
                        width: 300,
                        ellipsis: true,
                      },
                      {
                        title: "Unidad Medida",
                        dataIndex: "nombreUnidadMedida",
                        key: "nombreUnidadMedida",
                        width: 120,
                        ellipsis: true,
                      },
                      {
                        title: "Peso Unitario",
                        dataIndex: "pesoUnitario",
                        key: "pesoUnitario",
                        align: "center",
                        width: 90,
                        render: (data) => (
                          <span>{data.toFixed(2)}</span>
                      )
                      },
                      {
                        title: "Cantidad",
                        dataIndex: "cantidad",
                        key: "cantidad",
                        align: "center",
                        width: 90,
                        render: (data) => (
                          <span>{data.toFixed(2)}</span>
                      )
                      },
                      {
                        title: "Peso Total",
                        dataIndex: "totalPeso",
                        key: "totalPeso",
                        align: "center",
                        width: 90,
                        render: (data) => (
                          <span>{data.toFixed(2)}</span>
                      )
                      },
                    ]}
                  />
                </TabPane>
                <TabPane tab="Detalle de Referencias" key="2">
                  <Table
                    className={"table-referencia"}
                    scroll={{ x: true }}
                    size="small"
                    style={{ overflowX: "auto" }}
                    pagination={false}
                    dataSource={
                      this.props.formValues.listaComprobanteReferencia
                    }
                    rowKey={(record) => record.identifier}
                    columns={[
                      {
                        title: "Tipo Comprobante",
                        dataIndex: "nombreTipoComprobante",
                        key: "nombreTipoComprobante",
                        align: "center",
                        width: 350,
                        ellipsis: true,
                      },
                      {
                        title: "Serie",
                        dataIndex: "serie",
                        key: "serie",
                        width: 100,
                        ellipsis: true,
                      },
                      {
                        title: "Documento",
                        dataIndex: "documento",
                        key: "documento",
                        width: 120,
                        ellipsis: true,
                      },
                    ]}
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group" hidden={true}>
              <Form.Item label="Realizar transbordo programado">

                {getFieldDecorator("flagTransbordo", {
                  initialValue: this.props.formValues.flagTransbordo,
                  valuePropName: "checked",
                })(

                  <Checkbox
                    //checked={this.props.filter.incluirNotaVenta}
                    onChange={(e) => this.props.onChange("flagTransbordo", e.target.checked)}
                  ></Checkbox>

                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group" hidden={true}>
              <Form.Item label="Retorno de vehículo con envases o embalajes vacios">
                {getFieldDecorator("flagRetorno", {
                  initialValue: this.props.formValues.flagRetorno,
                  valuePropName: "checked",
                })(
                  <Checkbox
                    //checked={this.props.filter.incluirNotaVenta}
                    onChange={(e) => this.props.onChange("flagRetorno", e.target.checked)}
                  ></Checkbox>
                )}
              </Form.Item>
            </div>

            <div className="col-md-9 form-group">

            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Total Peso (KG)">
                {getFieldDecorator("totalPeso", {
                  initialValue: parseFloat(this.props.formValues.totalPeso).toFixed(
                    2
                  ),
                  rules: [
                    {
                      required: true,
                      pattern: new RegExp(GREATER_THAN_ZERO),
                      message: "Campo obligatorio mayor a 0.00",
                    },
                  ],
                })(
                  <Input
                    className="text-right"
                    placeholder="Ingresar peso total"
                    autoComplete="off"
                    onKeyPress={global.onKeyPressDecimals}
                    disabled={true}
                    onBlur={(e) => {
                      this.props.form.setFieldsValue({
                        totalPeso: global.onBlurDecimals(e, 2),
                      });
                    }}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row" hidden={true}>
            <div className="col-md-3 form-group">
              <Form.Item label="Traslado en vehículos de categoría M1 o L">
                {getFieldDecorator("flagCategoria", {
                  initialValue: this.props.formValues.flagCategoria,
                  valuePropName: "checked",
                })(
                  <Checkbox
                    //checked={this.props.filter.incluirNotaVenta}
                    onChange={(e) => this.props.onChange("flagCategoria", e.target.checked)}
                  ></Checkbox>
                )}
              </Form.Item>
            </div>
          </div>

        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModalVer);
